import React from 'react';
import Content from '../../components/content';
import Layout from '../layout';

const ContentContainer = () => (
  <Layout>
    <Content />
  </Layout>
);

export default ContentContainer;
